import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import WelcomeLayout from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/Welcome/Layout';
import { staticAppUrl } from 'Consts/sharedUris';
import useDarkHeaderTheme from 'Views/Onboarding/Hooks/useDarkHeaderTheme';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import WelcomeLowerContentWithParagraphsAndWelcomeBlurb
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeLowerContent/WelcomeLowerContentWithParagraphsAndWelcomeBlurb';

const styles = (theme) => ({
  root: {},
  image: {
    backgroundImage: `url(${staticAppUrl}/image/onboarding/income-welcome-updated.png)`,
  },
  text: {
    margin: theme.spacing(2),
  },
  title: {
    fontSize: 32,
    marginTop: theme.spacing(3),
  },
  paper: {
    margin: theme.spacing(2),
    padding: theme.spacing(2, 4),
    backgroundColor: theme.palette.facet.accentBlue,
    borderRadius: 20,
  },
});

function IncomeWelcomeLayout({
  className,
  classes,
}) {
  const { resource } = useMetaLayoutContext();
  useScrollTopOnMount();
  useDarkHeaderTheme();

  return (
    <WelcomeLayout
      classes={{
        root: classNames(className, classes.root),
        imageCardContainer: classes.image,
      }}
    >
      <WelcomeLowerContentWithParagraphsAndWelcomeBlurb resource={resource} />
    </WelcomeLayout>
  );
}

IncomeWelcomeLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

IncomeWelcomeLayout.defaultProps = {
  className: '',
};

export default withStyles(styles)(IncomeWelcomeLayout);
